








































import { Component, Vue } from 'vue-property-decorator';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';
import ActionTypes from '@/constants/action-types';

@Component
export default class MerchantDetailsHeader extends Vue {
  get merchant(): MerchantDetailsModel | null {
    const { merchant }: { merchant: MerchantDetailsModel | null } = this.$store.state.merchant;
    if (merchant && merchant.id === Number(this.$route.params.id)) {
      return merchant;
    }
    return null;
  }

  private async back(): Promise<void> {
    await this.$store.dispatch(`cart/${ActionTypes.EmptyCart}`);
    this.$store.commit(`cart/${ActionTypes.SetPickupDateTime}`, null);
    await this.$router.push('/');
  }

  private openInfoPopup(): void {
    this.$store.commit(`merchant/${ActionTypes.SetInfoPopupOpen}`, true);
  }
}
